if (typeof VideoControls !== 'function') {
  class VideoControls extends HTMLElement {
    constructor() {
      super()
      
      this.addEventListener('click', (event) => {
        event.preventDefault()

        const videos = this.parentElement.querySelectorAll("video")
        videos.forEach((video) => {
          video.muted = !video.muted
        })

        this.querySelector("#muted").classList.toggle('hidden')
        this.querySelector("#unmuted").classList.toggle('hidden')

      });

    }
  }
  if (!customElements.get('video-controls')) {
    customElements.define('video-controls', VideoControls)
  }
}